import { LOCAL_STORAGE_CLIENT_UUID } from "constants/localStore";
import { getLocalStorageOneItem, setLocalStorageOneItem } from "./localStorage";

const clearOfflineStorage: (args: { clearLocalStorage: boolean; clearSessionStorage: boolean }) => void = ({
  clearLocalStorage,
  clearSessionStorage,
}) => {
  const persistedUUID = getLocalStorageOneItem(LOCAL_STORAGE_CLIENT_UUID);

  if (clearLocalStorage) {
    localStorage.clear();
  }

  if (clearSessionStorage) {
    sessionStorage.clear();
  }

  if (persistedUUID) {
    setLocalStorageOneItem(LOCAL_STORAGE_CLIENT_UUID, persistedUUID);
  }
};

export { clearOfflineStorage };
